<template>
  <div :class="`lead-bottom-control-panel ${
        theme.isDark ? 'lead-bottom-control-panel_dark' : null
      }`">
    <ul class="d-flex flex-wrap lead-bottom-control-panel__controls" :class="{ show: !showCallCenter}">
      <li class="lead-bottom-control-panel__item" v-if="user.role_id == 1">
        <DeleteForm :lead_id="lead.id" />
      </li>
      <li
          class="lead-bottom-control-panel__item"
          v-if="lead.type_id === 4"
      >
        <HealthLeadMediaalphaForm
            btnText="Adjust"
            methods="update"
            :lead="lead"
            :baseData="baseData"
        />
      </li>
      <li
        class="lead-bottom-control-panel__item"
        v-else-if="lead.source == 'mediaalpha' && lead.type_id === 2"
      >
        <LeadBaseDataMediaalphaForm
          btnText="Adjust"
          methods="update"
          :lead="lead"
          :baseData="baseData"
        />
      </li>
      <li class="lead-bottom-control-panel__item" v-else-if="lead.type_id === 2">
        <LeadBaseDataForm
            btnText="Adjust"
            methods="update"
            :lead="lead"
            :baseData="baseData"
        />
      </li>
      <li class="lead-bottom-control-panel__item">
        <StatusDialog />
      </li>
      <li class="lead-bottom-control-panel__item" v-if="user_role_id == 1">
        <AsignmentAgentDialog />
      </li>
      <li class="lead-bottom-control-panel__item">
        <SendTextDialog :lead="lead" />
      </li>
      <li class="lead-bottom-control-panel__item">
        <SendEmailDialog :lead="lead" />
      </li>
    </ul>
    <div class="lead-bottom-control-panel__item">
      <CallCenter
          :lead_id="lead.id"
          :number="String(lead.phone)"
          :second_number="lead.second_phone?String(lead.second_phone):null"
          :status_lead="lead.status"
      />
    </div>
  </div>
</template>

<script>
import LeadBaseDataMediaalphaForm from "@/components/forms/LeadBaseDataMediaalphaForm";
import DeleteForm from "@/components/forms/DeleteForm";
import LeadBaseDataForm from "@/components/forms/LeadBaseDataForm";
import StatusDialog from "@/components/dialogs/StatusDialog";
import AsignmentAgentDialog from "@/components/dialogs/AsignmentAgentDialog";
import CallCenter from "@/components/twillio/CallCenter";
import SendTextDialog from "@/components/dialogs/SendTextDialog";
import SendEmailDialog from "@/components/dialogs/SendEmailDialog";
import HealthLeadMediaalphaForm from "@/components/forms/HealthLeadMediaalphaForm";
import { mapGetters } from "vuex";

export default {
  name: "LeadBottomControlPanel",
  inject: ["theme"],
  props: {
    lead: Object,
    baseData: Object,
    user_role_id: Number,
  },
  components: {
    LeadBaseDataMediaalphaForm,
    LeadBaseDataForm,
    StatusDialog,
    AsignmentAgentDialog,
    CallCenter,
    DeleteForm,
    SendTextDialog,
    SendEmailDialog,
    HealthLeadMediaalphaForm
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
    }),
    showCallCenter: {
      get: function () {
        if (this.lead.status == "notInterested") return false;
        return true;
      },
    },
  },
};
</script>

<style lang="scss">
.lead-bottom-control-panel {
  position: fixed;
  margin: 0;
  padding: 0;
  list-style: none;
  height: auto;
  bottom: 0;
  left: 56px;
  right: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: white;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12);
  &__item {
    list-style: none;
    transition: all .5s ease;
    width: auto;
    &:not(:last-child) {
      margin-right: 10px;
    }
  }
  &__btn {
    width: 64px;
    transition: all .5s ease;
    &:hover {
      width: 120px;
    }
    &:hover .lead-bottom-control-panel {
      &__item-text {
        opacity: 1;
        width: auto;
        margin-left: 5px;
      }
    }
  }
  &__item-text {
    transition: all .8s ease;
    width: 0;
    opacity: 0;
  }

  &_dark {
    background-color: #272727;
  }
}

.show {
  padding: 25px 0;
}

@media screen and (max-width: 1440px) {
  .lead-bottom-control-panel {
    flex-direction: column;
  }
  .lead-bottom-control-panel__controls {
    margin-top: 15px;
  }
}
</style>